import {
  createContext,
  useCallback,
  useContext,
  useState,
  ReactNode,
} from 'react';

// Toast type
interface Toast {
  id: number;
  title: string;
  message: string;
}

// Context type
const ToastContext = createContext<(title: string, message: string) => void>(
  () => {}
);

export function useToast() {
  return useContext(ToastContext);
}

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const showToast = useCallback((title: string, message: string) => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, title, message }]);
    setTimeout(
      () => setToasts((prev) => prev.filter((t) => t.id !== id)),
      3000
    );
  }, []);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div className="fixed top-8 right-8 z-50 space-y-2">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className="bg-white shadow-lg rounded-lg znario:rounded-none znario:bg-base-100 px-6 py-4 border border-gray-200"
            style={{ minWidth: 320 }}
          >
            <div className="font-bold text-lg text-black mb-1">
              {toast.title}
            </div>
            <div className="text-gray-700 text-base">{toast.message}</div>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};
